import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

export const SessionsCard = ({ data, onOpen }) => {
  const { t } = useTranslation();
  if (!data) return null;

  return (
    <NeuCard
      data-testid="system-sessions-card"
      onClick={onOpen}
      className="cursor-pointer transition-transform duration-300 hover:-translate-y-0.5"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="label-xs flex items-center gap-2">
          <Users className="h-4 w-4 text-primary" /> {t("system.sessions")}
        </p>
        <span className="flex items-center gap-2 rounded-full bg-background px-3 py-1 text-xs font-bold shadow-neu-sm">
          <span className="h-2 w-2 animate-pulse rounded-full bg-primary" />
          {t("system.onlineNow", { count: data.online, minutes: data.online_minutes })}
        </span>
      </div>

      {!data.items.length ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="system-sessions-empty">
          {t("system.noSessions")}
        </p>
      ) : (
        <ul className="mt-4 grid gap-2" data-testid="system-session-list">
          {data.items.map((item, i) => (
            <li
              key={`${item.name}-${i}`}
              className="flex items-center justify-between gap-3 rounded-2xl bg-background px-3 py-2.5 shadow-neu-sm"
            >
              <div className="min-w-0">
                <p className="truncate text-xs font-bold">
                  <span className={`me-2 inline-block h-2 w-2 rounded-full ${item.online ? "bg-primary" : "bg-muted-foreground/40"}`} />
                  {item.name}
                </p>
                <p className="truncate text-[11px] text-muted-foreground">
                  {t(`roles.${item.role}`, item.role)} · {item.company}
                </p>
              </div>
              <div className="shrink-0 text-end">
                <p className="text-[11px] font-bold">{item.country}{item.city ? ` · ${item.city}` : ""}</p>
                <p className="font-mono text-[10px] text-muted-foreground num">
                  {item.device} · {(item.last_seen_at || "").slice(11, 16)}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </NeuCard>
  );
};
